import { settlementPeriodName } from 'services/settlementPeriods/types';
import {
  EMAIL_SEND,
  IInfinitePageParams,
  IInfinitePageResponse,
  IInfinitePageStatisticsResponse,
  ITotalPageCount,
} from 'services/types';

// Wspólne

export interface ILabelReportsSearch extends IInfinitePageParams {}

export enum REPORT_GENERATION_STATUS {
  Waiting = 1,
  Done = 2,
  Error = 3,
  Canceled = 4,
  InProgress = 5,
}

export interface GetAllReportsParams {
  page: number;
  itemCount: number;
}

export interface ILabelReportRemove {
  labelReportId: string;
}

// Dla Label Report

export interface ISettlementPeriodName {
  name: string;
  year: number;
}

export interface ISettlementPeriodName {
  name: string;
  year: number;
}

export interface ILabelReportResponse {
  id: string;
  labelReportNumber: string;
  startSettlementPeriodId: string;
  endSettlementPeriodId: string;
  labelId: string;
  labelName: string;
  amountEarned: number;
  amountForLabel: number;
  amountForOwner: number;
  sendStatus: EMAIL_SEND;
  filePath: string | null;
  detailedFilePath: string | null;
  contractEarnings: number | null;
  startSettlementPeriodName: ISettlementPeriodName;
  endSettlementPeriodName: ISettlementPeriodName;
  canGenerateDetailedReport: boolean;
  isOutdated?: boolean;
}

export interface ILabelReportStatistics {
  allAmountEarned: number;
  allAmountForLabel: number;
  allAamountForOwner: number;
}

export interface ILabelReportPageResponse
  extends IInfinitePageResponse<ILabelReportResponse> {}

export interface IGetLabelReportInfiniteParams {
  startSettlementPeriodDate?: string;
  endSettlementPeriodDate?: string;
  Page?: number;
  ItemCount?: number;
}

export interface SettlementPeriodResponse {
  id: string;
  settlementPeriodName?: settlementPeriodName;
  startDate?: string;
  endDate?: string;
}

export interface ILabelReportsByLabelResponseContractEarning {
  contractId: string;
  earningAmount: number;
  remainingNetAmount: number;
}

export interface ILabelReportsByLabelResponse {
  id: string;
  startSettlementPeriodId: string;
  startSettlementPeriodName: ISettlementPeriodName;
  endSettlementPeriodId: string;
  endSettlementPeriodName: ISettlementPeriodName;
  labelId: string;
  amountEarned: number;
  amountForLabel: number;
  amountForOwner: number;
  labelReportNumber: string | null;
  sendStatus: EMAIL_SEND;
  filePath: string | null;
  detailedFilePath: string | null;
  contractEarnings: ILabelReportsByLabelResponseContractEarning[];
  createdAt: string;
  editedAt: null | string;
  canGenerateDetailedReport: boolean;
  isOutdated?: boolean;
}

export interface ILabelReportStatistics {
  allAmountEarned: number;
  allAmountForLabel: number;
  allAmountForOwner: number;
}

export interface ILabelReportsSearchResponse {
  statistics: ILabelReportStatistics;
  items: ILabelReportsByLabelResponse[];
  totalPageCount: number;
}

export interface ILabelReportsByLabelParams extends IInfinitePageParams {
  startSettlementPeriodId?: string;
  endSettlementPeriodId?: string;
}

export interface ILabelReportsByLabelResponseInfinite
  extends IInfinitePageStatisticsResponse<
    ILabelReportsByLabelResponse,
    ILabelReportStatistics
  > {}

export interface ILabelReportsOrderResponse {
  id: string;
  labelId: string;
  startSettlementPeriod: SettlementPeriodResponse;
  endSettlementPeriod: SettlementPeriodResponse;
  labelName?: string;
  reportGenerationStatusId: REPORT_GENERATION_STATUS;
  plannedStartDate: string;
}
export interface ILabelReportsOrderQueueResponse {
  id: string;
  labelId: string;
  startSettlementPeriodName: settlementPeriodName;
  endSettlementPeriodName: settlementPeriodName;
  labelName?: string;
  reportGenerationStatusId: REPORT_GENERATION_STATUS;
  plannedStartDate: string;
}

export interface ILabelReportMutationForm {
  labelId: string;
  startSettlementPeriodId: string;
  endSettlementPeriodId: string;
  planedStartDate: string;
  asap: boolean;
}

export interface IGetSearchLabelReports {
  startSettlementPeriodDate?: string;
  endSettlementPeriodDate?: string;
  page?: number;
  itemCount?: number;
}

export interface ICreateLabelReport
  extends Omit<ILabelReportMutationForm, 'planedStartDate'> {
  planedStartDate: string | null;
}

export interface ICancelLabelReport {
  labelReportOrderId: string;
}

export interface ILabelPeriodReportsOrderPageResponse
  extends IInfinitePageResponse<ILabelReportsOrderResponse> {}

export interface ILabelReportsOrderPageResponse
  extends IInfinitePageResponse<ILabelReportsOrderResponse> {}

// Dla PERIOD REPORT

export interface LabelReportsOrderResponse {
  id: string;
  settlementPeriod: SettlementPeriodResponse;
  reportGenerationStatusId: REPORT_GENERATION_STATUS;
  plannedStartDate: string;
  labelGenerationStatus: ILabelGenerationStatusResponse;
}

export interface ILabelGenerationStatusResponse {
  labelId: string;
  labelName: string;
  reportGenerationStatusId: REPORT_GENERATION_STATUS;
}

export interface IPeriodReportMutationForm {
  settlementPeriodId: string;
  planedStartDate: string;
  asap: boolean;
}

export interface ICreatePeriodReport
  extends Omit<IPeriodReportMutationForm, 'planedStartDate'> {
  planedStartDate: string | null;
}

export interface ICancelPeriodReport {
  labelReportOrderId: string;
}

export interface IPeriodReportOrderPageResponse
  extends IInfinitePageResponse<LabelReportsOrderResponse> {}

export interface IPeriodReportPageResponse extends ITotalPageCount {
  periodReportResponse: LabelReportsOrderResponse[];
}

export interface ICheckLabelReportPeriodsParams {
  labelId: string;
  startSettlementPeriodId: string;
  endSettlementPeriodId: string;
}

export interface ICheckLabelReportPeriodsResponse {
  hasOverlappingPeriods: boolean;
  isAlreadySettled: boolean;
}

export interface ILabelReportDetailContractEarning {
  contractId: string;
  amountEarned: number;
  amountEarnedLabel: number;
  remainingNetAmount: number;
  contractTitle: string;
}

export interface ILabelReportDetailSalesChannelRow {
  salesChannelId: string;
  divisionPercentage: number;
  salesChannelName: string;
  amountEarned: number;
  amountLabelEarned: number;
}

export interface ILabelReportDetailGroupedItem {
  title: string;
  amountEarned: number;
  amountLabelEarned: number;
  ean: string;
  isrc: string;
  titleVersion: string;
  secondTitle: string;
  channelId: string;
  videoId: string;
  salesChannelRows: ILabelReportDetailSalesChannelRow[];
}

export interface ILabelReportDetailResponse {
  id: string;
  labelReportNumber: string;
  startSettlementPeriodId: string;
  endSettlementPeriodId: string;
  labelId: string;
  labelName: string;
  amountEarned: number;
  amountForLabel: number;
  amountForOwner: number;
  sendStatus: number;
  isOutdated: boolean;
  canGenerateDetailedReport: boolean;
  filePath: string;
  detailedFilePath: string;
  contractEarnings: ILabelReportDetailContractEarning[];
  startSettlementPeriodName: ISettlementPeriodName;
  endSettlementPeriodName: ISettlementPeriodName;
  groupedProductData: ILabelReportDetailGroupedItem[];
  groupedChannelData: ILabelReportDetailGroupedItem[];
  groupedSalesChannelList: ILabelReportDetailSalesChannelRow[];
  groupedChannels: ILabelReportDetailGroupedItem[];
  groupedProducts: ILabelReportDetailGroupedItem[];
}
